import PageTemplate from "@/components/templates/PageTemplate";
import { DownloadsPageLayout } from "@/components/support/layouts/DownloadsPageLayout";
import Downloads from "@/components/support/downloads/Downloads";
import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";
import {
  DownloadsEnum,
  resolveDownloadsType,
} from "@/v2-components/pages/support/types/support-downloads-type";
import { getLocalePrefix } from "@/libs/i18n/getLocalePrefix";

const DownloadsPage = () => {
  return (
    <PageTemplate>
      <PageTemplate.Content>
        <DownloadsPageLayout>
          <Downloads />
        </DownloadsPageLayout>
      </PageTemplate.Content>
    </PageTemplate>
  );
};

const VALID_DOWNLOAD_TYPES = Object.values(DownloadsEnum) as string[];

export const handleRedirect = (query: Record<string, any>, locale?: string) => {
  const type = String(query.type ?? "");
  if (VALID_DOWNLOAD_TYPES.includes(type)) return null;

  // 누락 → Player · 없어진 탭의 옛 값 → 정해 둔 탭 · 그 밖 → Manual(SSR 렌더 크래시 #5025 차단).
  // 규칙은 `resolveDownloadsType` 하나 — 탭 컨테이너·레이아웃도 같은 함수를 쓴다.
  const target = resolveDownloadsType(query.type);
  const localePrefix = getLocalePrefix(locale);
  return {
    redirect: {
      destination: `${localePrefix}/support/downloads/?type=${target}`,
      permanent: false,
    },
  };
};

export async function getServerSideProps(context) {
  const { query, locale } = context;

  const redirect = handleRedirect(query, locale);
  if (redirect) return redirect;

  return {
    props: {
      ...(await serverSideTranslations(locale, ["support", "index", "gnb"])),
    },
  };
}

export default DownloadsPage;
